import React from 'react';
import { useField } from 'formik';
import { handleBalanceKeyDown, formatBalanceValue } from '../../../utilities/balanceUtils';


const BalanceInput = ({ ...props }) => {
  const [field, meta, helpers] = useField(props);

  const handleChange = (e) => {
    field.onChange(e);
    
    const formattedValue = formatBalanceValue(e.target.value);
    if (formattedValue !== e.target.value) {
      e.target.value = formattedValue;
      helpers.setValue(parseFloat(formattedValue));
    }
  };

  return (
    <input
      {...field}
      {...props}
      onChange={handleChange}
      onKeyDown={handleBalanceKeyDown}
    />
  );
};

export default BalanceInput; 